import React from 'react';
import { translate } from 'react-i18next';

import ScheduleWeekBlock from 'components/ScheduleWeekBlock.js';
import BrandFooter from 'components/BrandFooter.js';

class ScheduleCalendar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const block = [];
    const maxNumberOfWeeks = 6;

    for (let i = 0; i < maxNumberOfWeeks + 1; i++) {
      block.push(
        <ScheduleWeekBlock
          key={i}
          clearSelectedShiftId={this.props.clearSelectedShiftId}
          selectedExchangeShift={this.props.selectedExchangeShift}
          week={i + 1}
          selectedShift={this.props.selectedShift}
          domSet="false"
          month={this.props.month}
          year={this.props.year}
          allShiftActivity={this.props.allShiftActivity}
          onDaySelect={this.props.onDaySelect}
          exchangeDaySelectMode={this.props.exchangeDaySelectMode}
          selectedExchangeDays={this.props.selectedExchangeDays}
          removeSelectedDay={this.props.removeSelectedDay}
        />,
      );
    }

    return (
      <article className="month">
        <header>
          <div className="day-label">{moment.weekdays(0)}</div>
          <div className="day-label">{moment.weekdays(1)}</div>
          <div className="day-label">{moment.weekdays(2)}</div>
          <div className="day-label">{moment.weekdays(3)}</div>
          <div className="day-label">{moment.weekdays(4)}</div>
          <div className="day-label">{moment.weekdays(5)}</div>
          <div className="day-label">{moment.weekdays(6)}</div>
        </header>
        <div>{block}</div>
        <BrandFooter
          brand={window.EmployeeWeb.ENVConfig.brand}
          key={_.uniqueId()}
          year={new Date().getFullYear()}
          privacyLink={window.EmployeeWeb.ENVConfig.privacy_link}
          termsLink={window.EmployeeWeb.ENVConfig.terms_link}
        />
      </article>
    );
  }
}

export default translate()(ScheduleCalendar);
